<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M9.16699 10.8337L9.16699 18.3339"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.16699 2.00202V4.50251"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.12549 4.5021C2.90443 4.5021 2.69243 4.58991 2.53612 4.74622C2.37981 4.90253 2.29199 5.11454 2.29199 5.33559L2.29199 9.50307C2.29199 9.72413 2.37981 9.93613 2.53612 10.0924C2.69243 10.2488 2.90443 10.3366 3.12549 10.3366L13.9609 10.3366C14.3047 10.3366 14.6401 10.2303 14.9211 10.0323L17.775 8.10113C17.8842 8.0242 17.9733 7.92214 18.0349 7.80355C18.0964 7.68497 18.1285 7.55334 18.1285 7.41975C18.1285 7.28616 18.0964 7.15453 18.0349 7.03595C17.9733 6.91737 17.8842 6.81531 17.775 6.73837L14.9211 4.80632C14.6401 4.60833 14.3047 4.50207 13.9609 4.5021L3.12549 4.5021Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconCoordinator',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: '#49B4BC'
		},
		filled: {
			type: Boolean,
			default: false
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.3
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
